import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

type Props = {
  title: string,
  onClosePanel: () => void,
  onCloseAllPanels: () => void
};

const SidePanelHeader = ({
  title,
  onClosePanel,
  onCloseAllPanels
}: Props) => (
  <div className="side-panel-header">
    <span>{title}</span>
    <div
      className="side-panel-header__back-button"
      onClick={onClosePanel}
    >
      <SVGDynamicIcon
        name="chevron-left-custom-fg"
        height={10}
        width={10}
        customColor="grey"
      />
    </div>
    <div
      className="side-panel-header__close-button"
      onClick={onCloseAllPanels}
    >
      <SVGDynamicIcon
        name="cross-custom-fg"
        height={10}
        width={10}
        customColor="grey"
      />
    </div>
  </div>
);

export default SidePanelHeader;
